export default "https://cdn-static.gokick.com/assets/0d39bc0fcec85c93d0d6a7d8f262b967dc26f977/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";